import { Directive, OnInit, OnDestroy, SimpleChange } from '@angular/core';
import { DomicileService } from '../services/domicile.service';
import { NgSelectComponent } from '@ng-select/ng-select';
import { Subscription } from 'rxjs';
import { SesionService } from '../services/sesion.service';
import { EgonService } from '../services/egon.service';
import { NgModel } from '@angular/forms';
import { LanguageService } from '../services/language.service';


@Directive({
  selector: '[location]',
  host: { 'class': 'dhl' }
})
export class LocationDirective implements OnInit, OnDestroy {

  constructor(
    private select: NgSelectComponent,
    private houseService: DomicileService,
    private model: NgModel,
    private sesion: SesionService,
    private egonService: EgonService,
    private langService: LanguageService,
  ) {
    this.select.addTag = true;
    this.select.addTagText = '';
    this.select.selectOnTab = true;

  }
  subscriptionLocationes: Subscription;


  private _notFound = '';
  get noEncontrado(): string {
    return this._notFound;
  }
  private subscriptionChange: Subscription;
  private localities = new Array<string>();
  private firstChange = true;
  private subscriptionClear: Subscription;
  //@HostBinding('class.dhl') dhl = true;
  ngOnInit() {
    this.subscriptionChange = this.select.changeEvent.subscribe(location => {
      if (!location) {
        return;
      }
      this.houseService.location$.next(location);
      if (this.egonService.disponible) {
        if (this.localities.indexOf(location) === -1) {
          this.model.control.setErrors({
            'localidaCodigoPostal': this.langService.instant('Shared.TownZipCodeInfo')
          }, { emitEvent: true });
          this._notFound = location;
          this.select.ngOnChanges({
            items: new SimpleChange(this.select.items, [...this.localities, location], this.firstChange)
          });
          this.firstChange = false;          
        } else {
          this.select.ngOnChanges({
            items: new SimpleChange(this.localities, this.localities, this.firstChange)
          });
          this.firstChange = false;
          this._notFound = '';
        }
      }
    });

    this.subscriptionClear = this.select.clearEvent.subscribe(() => {
      this.select.ngOnChanges({
        items: new SimpleChange(this.localities, this.localities, this.firstChange)
      });
      this.firstChange = false;
      this._notFound = '';
    });
    this.subscriptionLocationes = this.houseService.localities$.subscribe(localities => {
      this.select.ngOnChanges({
        items: new SimpleChange(this.localities, localities.map(l => l.City), this.firstChange)
      });
      const seleccionar = !this.firstChange;
      this.firstChange = false;
      this.localities = localities.map(l => l.City);

      if (this.select.selectedItems.length > 0) {
        this.select.unselect(this.select.selectedItems[0]);
      }
      if (this.select.itemsList.items.length > 0) {
        this.select.select(this.select.itemsList.items[0]);
      }
      if (seleccionar) {
        this.select.focus();
      }
    });
  }

  ngOnDestroy(): void {
    if (this.subscriptionChange) {
      this.subscriptionChange.unsubscribe();
    }
    if (this.subscriptionLocationes) {
      this.subscriptionLocationes.unsubscribe();
    }
    if (this.subscriptionClear) {
      this.subscriptionClear.unsubscribe();
    }
  }

  get value(): string {
    return (this.select && this.select.selectedValues.length > 0) ? (<string>this.select.selectedValues[0]) : '';
  }
}
